import { render, staticRenderFns } from "./RCA.vue?vue&type=template&id=194f8c96&scoped=true"
import script from "./RCA.vue?vue&type=script&lang=js"
export * from "./RCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f8c96",
  null
  
)

export default component.exports